import React from 'react'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'
import {useThemeMode} from '../../../../../_metronic/partials'
import {RecordAccessRequestProps} from '../../core/_models'
import {recordsKeeperColors} from '../../core/_constants'

export const MultilineChart = ({
  recordAccessRequestData,
}: {
  recordAccessRequestData: RecordAccessRequestProps
}) => {

    
  const {mode} = useThemeMode()

  const options: ApexOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false, // This will remove the toolbar from the top left
      },
    },
    stroke: {
      width: [3, 3, 3],
      curve: 'smooth',
    },
    labels: recordAccessRequestData.labels,
    xaxis: {
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    grid: {
      show: true,
      borderColor: mode === 'dark' ? '#565674' : '#DBDFE9',
      strokeDashArray: 0,
      position: 'back',
    },
    colors: recordsKeeperColors,
    legend: {
      show: false,
      position: 'bottom', // You can change the position as needed (top, right, bottom, left)
      horizontalAlign: 'center', // Aligns the legend horizontally (left, center, right)
      labels: {
        colors: mode === 'dark' ? '#ffffff' : '#000000',
      },
      markers: {
        width: 10,
        height: 10,
      },
    },
  }

  return (
    <div>
      <div id='chart'>
        <Chart
          options={options}
          series={recordAccessRequestData.users.map((user) => ({
            name: user.fullName,
            data: Object.values(user.dailyData),
          }))}
          type='line'
          height={350}
        />
      </div>
      <div id='html-dist'></div>
    </div>
  )
}
